'use client'
import Image from 'next/image';
import starIcon from '../../public/images/ic_stars.svg'

export default function PrivacyPolicy() {
  return (
    <div  className="container">
      <div style={{ padding: '40px 20px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
        <h1 style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '32px', marginBottom: '40px' }}>
          Terms of Use
        </h1>

        {sections.map((section, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '30px' }}>
            <Image
              src={starIcon}
              alt="Section Star"
              width={24}
              height={24}
              style={{ marginRight: '10px' }}
            />
            <div>
              <h2 style={{ fontSize: '18px', fontWeight: 'bold', margin: '0 0 10px' }}>{section.title}</h2>
              <p style={{ fontSize: '16px', margin: 0, lineHeight: '1.6' }}>{section.description}</p>
              {section.subItems && (
                <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                  {section.subItems.map((item, idx) => (
                    <li key={idx} style={{ fontSize: '16px', lineHeight: '1.6' }}>
                      <strong>{item.label}:</strong> {item.text}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const sections = [
  {
    title: 'Notice',
    description:
      "Please read these terms of use carefully. by accessing this website and its pages, you agree to be bound by these terms of use, as they may be modified from time to time and posted on this site by sapphire software solutions."
  },
  {
    title: 'Copyright © Sapphire Software Solutions. 2012',
    description:
      "www.sapphirehealth.net is owned by sapphire software solutions. all content present on this site is the exclusive property of sapphire software solutions including all the software, text, images, graphics and video used on this site. certain screen layouts and graphics contained in this site that are not owned by sapphire software solutions are exclusively licensed to sapphire software solutions. no material from this site may be copied, modified, reproduced, republished, uploaded, transmitted, posted or distributed in any form without prior written permission from sapphire software solutions.unauthorized use of the materials appearing on this site may violate copyright, trademark and other applicable laws.",
  },
  {
    title: 'Use Of Information',
    description:
      'The information provided on this site is free of charge and is for informational purposes only. the content in this site, including the terms, conditions and descriptions herein are subject to change without prior notice to you. unauthorized use of, or entry into the site, the misuse of information contained within this site, is strictly prohibited.',
  },
  {
    title: 'Links To Other Sites',
    description:
      'Sapphire may establish in this site links and pointers to websites maintained and operated by third parties. access to these links is at your sole discretion. the establishment of any link in this site does not imply an endorsement or recommendation by sapphire software solutions of any opinions, ideas, goods, products, information or services offered through such linked websites. any use you make of the information provided on this site, or any site or service linked to by this site, is at your own risk. sapphire software solutions has no control over such third party websites and makes no warranties or representations as to any content in, or goods, products or services offered through, such third party websites.',
  },
  {
    title: 'Disclaimer Of Warranties',
    description:
      'The information contained in the site has been obtained from sources believed to be reliable. the site, and all content, materials, information, software, products and services provided on the site, are provided on an “as is” and “as available” basis. sapphire software solutions makes no warranties, express or implied, including, without limitation, those of merchantability and fitness for a particular purpose or infringement, with respect to any information, data, statements or products made available on the site. sapphire software solutions disclaims all warranties as to the accuracy, completeness or adequacy of such information.',
  },
  {
    title: 'Limitation Of Liability',
    description:
      'Sapphire shall have no responsibility for any damage to user’s computer system or loss of data those results from the download of any content, materials, information from the site. sapphire will not be liable for damages of any kind, including without limitation, direct, incidental or consequential damages (including, but not limited to, damages for lost profits, business interruption and loss of programs or information) arising out of the use of or inability to use the site, or any information provided on the site, or for any other reason whatsoever.',
  },
  {
    title: 'Indemnification',
    description:
      'Indemnification user agrees to indemnify, defend and hold sapphire software solution harmless from and against all losses, expenses, damages and costs, including reasonable attorneys’ fees, arising out of or relating to any misuse by the user of the content and services provided on the site.',
  },
  {
    title: 'Right To Modify Or Terminate',
    description:
      'sapphire reserves the right to modify the services offered in this site. sapphire also reserves the right to terminate your access to such products and services, or access to the site, in whole or in part, at any time.',
  },
  {
    title: 'Governing Law And Jurisdiction',
    description:
      'If you attempt to bring any legal proceedings against sapphire software solutions, you acknowledge that sapphire software is free to choose the jurisdiction of our preference as to where such action against us may be held. we can make the decision entirely as it suits us, without regard to where in the world you are located, or from where in the world you visited this site.',
  },



];
